import { createClient } from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

export const client = createClient({
  projectId: 'scoss99s',
  dataset: 'production',
  useCdn: true,
  apiVersion: '2023-05-03',
})

const builder = imageUrlBuilder(client)

export function urlFor(source) {
  if (!source) return { url: () => '' }
  return builder.image(source)
}

/**
 * Fetch all gallery items from Sanity sorted by order field
 */
export async function getGalleryItems() {
  try {
    const query = `*[_type == "galleryItem"] | order(order asc)`
    return await client.fetch(query)
  } catch (err) {
    console.error('Error fetching gallery items from Sanity:', err)
    return null
  }
}

/**
 * Fetch all client reviews from Sanity sorted by order field
 */
export async function getReviews() {
  try {
    const query = `*[_type == "review"] | order(order asc)`
    return await client.fetch(query)
  } catch (err) {
    console.error('Error fetching reviews from Sanity:', err)
    return null
  }
}

/**
 * Fetch the global site settings document
 */
export async function getSiteSettings() {
  try {
    const query = `*[_type == "siteSettings"][0]`
    return await client.fetch(query)
  } catch (err) {
    console.error('Error fetching site settings from Sanity:', err)
    return null
  }
}
